// !FIXME - Easy - Flow type this file
import React from 'react'
// !FIXME - Medium - Using List here doesn't seem to make any sense.
// Change the tree counter to just use a div.. :P
import { Grid, List, Image } from 'semantic-ui-react'
import { textBrownColor, prussian } from 'constants/inlineStyles'
import { css } from 'emotion'

let styles = {}

// !FIXME - Medium - Match tree counter spacing to mock
// !FIXME - Medium - Move SVG to own .svg file
const FlyerTreeHeader = ({
  header = '',
  coBrandingUrl,
  coBrandingAlt,
  coBrandingLogoLink,
  sheetsSaved = 0,
  treesSaved = 0,
  showCounters = true
}) => {

  const getCoBrading = () => {
    const coBradingImg =
      <img
        alt={coBrandingAlt || 'District or School Logo'}
        src={coBrandingUrl}
      />

    return (
      <div>
        {coBrandingLogoLink ? (
          <a href={coBrandingLogoLink} target="_blank">
          {coBradingImg}
        </a>
        )
        : coBradingImg
      }
      </div>
    )
  }

  return (
  <div className={cn.container}>
    <Grid stackable >
      <Grid.Row columns={3}>
        <Grid.Column style={styles.singleColumn} className="mobile hidden"/>
        <Grid.Column>
          <div className={cn.titleContainer}>
            {coBrandingUrl && getCoBrading()}
            <div>
              <h1>{header}</h1>
            </div>
          </div>
        </Grid.Column>
        <Grid.Column style={styles.sheetsContainer} className="mobile hidden" >
          {showCounters && (
            <div style={styles.countersWrapper}>
              <div style={styles.svgWrapper}>
                <Image
                  as="img"
                  alt="Tree Saved Icon"
                  src="https://s3.amazonaws.com/peachjar-assets/FlyerLandingPage-Assets/Icon-Trees.svg"
                />
              </div>
              <List horizontal>
                <List.Item>
                  <List.Content verticalAlign="top">
                    <span style={styles.counterLabel}>Sheets Saved</span>
                  </List.Content>
                  <List.Content verticalAlign="top">
                    <span style={styles.counterValue}>
                      {sheetsSaved.toLocaleString()}
                    </span>
                  </List.Content>
                </List.Item>
              </List>

              <List horizontal>
                <List.Item>
                  <List.Content verticalAlign="bottom">
                    <span style={styles.counterEqualSign}>=</span>
                  </List.Content>
                </List.Item>
              </List>
              <List horizontal>
                <List.Item>
                  <List.Content verticalAlign="top">
                    <span style={styles.counterLabel}>Trees Saved</span>
                  </List.Content>
                  <List.Content verticalAlign="top">
                    <span style={styles.counterValue}>
                      {Math.round(treesSaved).toLocaleString()}
                    </span>
                  </List.Content>
                </List.Item>
              </List>
            </div>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
  )
}

styles = {
  singleColumn: { flex: '1 1 auto', display: 'flex', alignItems: 'center' },
  sheetsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  doubleColumn: { flex: '2 1 auto' },
  countersWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'flex-end',
    textAlign: 'center'
  },
  svgWrapper: { alignSelf: 'center' },
  counterLabel: { fontSize: '.875em' },
  counterValue: { fontSize: '.75em', color: textBrownColor },
  counterEqualSign: { fontSize: '1em' }
}

const cn = {
  container: css`
    margin-top: 32px;
    margin-bottom: 12px;
    @media (max-width: 480px) {
      margin-top: 24px;
    }
  `,
  titleContainer: css`
    display: flex;
    align-items: center;
    min-height: 60px;
    justify-content: center;
    & img {
      height: 60px;
    }
    & h1 {
      font-family: 'Proxima Nova';
      font-size: 28px;
      line-height: 32px;
      margin-left: 10px;
      font-weight: 600;
      color: ${prussian};
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 416px;
    }
    @media (max-width: 480px) {
      min-height: 48px;
      & img {
        height: 48px;
      }
      & h1 {
        font-size: 22px;
        line-height: 32px;
        white-space: normal;
        max-width: 360px;
      }
    }
  `,
}

export default FlyerTreeHeader



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerTreeHeader/index.js